<template>
  <settings-checker>
    <div class="booking">
      <div class="booking-wrapper booking-payment-processor">
        <petstar-ribbon />
        <div class="booking-divider booking-divider-left">
          <div class="booking-content">
            <booking-header />
            <div class="section-header d-flex">
              Booking Payment Summary
            </div>
            <payment-summary />
          </div>
          <div class="fixed-buttons d-none d-md-block">
            <home-button />
          </div>
        </div>
        <div v-if="loadingBookingPayment" class="booking-divider booking-divider-right booking-payment-widget">
          <div class="booking-content">
            <span class="inline-loader m-auto"></span>
          </div>
        </div>
        <div v-else-if="!loadingBookingPayment && !bookingPayment" class="booking-divider booking-divider-right d-flex">
          <error-banner v-if="error" :message="error" class="my-auto mx-auto"/>
        </div>
        <template v-else>
          <confirmation v-if="closed" :token="token"/>
          <template v-else>
            <sumup-widget v-if="providerTypeId == 1"
              :payment="bookingPayment"
              @completed="tryUpdateBookingPaymentAnonymous" />
            <lopay-widget v-else-if="providerTypeId == 2"
              :payment-link="bookingPayment.link"
              @completed="tryUpdateBookingPaymentAnonymous" />
          </template>
        </template>
      </div>
    </div>
  </settings-checker>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'
import PetstarRibbon from '@/components/Booking/PetstarRibbon.vue'
import Header from '@/components/Booking/Header.vue'
import SettingsChecker from '@/components/Booking/SettingsChecker.vue'
import SumUpWidget from '../SumUpWidget.vue'
import LopayWidget from '../LopayWidget.vue'
import PaymentSummary from '../PaymentSummary.vue'
import Confirmation from './Confirmation.vue'
import HomeButton from '@/components/Booking/HomeButton.vue'

export default {
  name: 'PaymentProcessor',
  mixins: [SiteBookingSettingMixin],
  computed: {
    ...mapState('BookingPayment', [
      'bookingPayment',
      'loadingBookingPayment'
    ]),
    providerTypeId () {
      return this.bookingPayment?.providerTypeId || 0
    },
    token () {
      return this.$route.query.token
    },
    status () {
      return this.bookingPayment?.status || null
    },
    closed () {
      return this.status && this.status.id > 2
    }
  },
  watch: {
    token () {
      this.refreshBookingPayment()
    }
  },
  methods: {
    ...mapActions('BookingPayment', [
      'fetchBookingPaymentAnonymous',
      'updateBookingPaymentAnonymous'
    ]),
    refreshBookingPayment () {
      if (!this.bookingPayment) {
        this.tryFetchBookingPaymentAnonymous()
      }
    },
    tryFetchBookingPaymentAnonymous () {
      const self = this
      self.error = ''
      if (!self.token || self.loadingBookingPayment) {
        return
      }
      self.fetchBookingPaymentAnonymous({ token: self.token })
        .catch(error => { self.error = ErrorHelper.getError(error) })
    },
    tryUpdateBookingPaymentAnonymous () {
      const self = this
      self.error = ''
      if (!self.token || self.loadingBookingPayment) {
        return
      }
      self.updateBookingPaymentAnonymous({ token: self.token })
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshBookingPayment()
  },
  components: {
    'settings-checker': SettingsChecker,
    'petstar-ribbon': PetstarRibbon,
    'booking-header': Header,
    'payment-summary': PaymentSummary,
    'sumup-widget': SumUpWidget,
    'lopay-widget': LopayWidget,
    confirmation: Confirmation,
    'home-button': HomeButton,
    'error-banner': ErrorBanner
  }
}
</script>

<style>
  .booking-payment-processor .booking-divider-right.booking-payment-widget .booking-content {
    max-height: calc(100% - 8.25rem) !important
  }
  .booking-payment-processor .booking-divider-right.booking-payment-widget .fixed-buttons {
    height: 8.25rem !important
  }
</style>
